import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StyledPanel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
`;

export const StyledVerticalFlex = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `
);
